/* --- START: Edited by Copilot Space (typed env usage, no 'any', credentials enabled) --- */
import axios from 'axios';

// Read Vite environment variable in a type-safe way.
// Vite provides types via src/vite-env.d.ts (ImportMetaEnv).
const env: ImportMetaEnv | undefined =
  typeof import.meta !== 'undefined' ? import.meta.env : undefined;

// Prefer explicit API base URL from env; fall back to same-origin (when frontends are proxied)
// and finally to localhost for development.
const apiBaseFromEnv = env?.VITE_API_BASE_URL?.trim();
const apiBaseFromWindow =
  typeof window !== 'undefined' ? window.location.origin : undefined;

// Decide the base, removing any trailing slash before adding /api.
const API_BASE =
  apiBaseFromEnv ||
  apiBaseFromWindow ||
  'http://localhost:8000';

const baseURL = `${API_BASE.replace(/\/$/, '')}/api`;

// Axios instance configured for cookie-based flows and reasonable timeout.
const api = axios.create({
  baseURL,
  timeout: 10000,
  withCredentials: true,
});

// Optional: centralized error logging (kept minimal here to avoid side-effects)
api.interceptors.response.use(
  (res) => res,
  (err) => Promise.reject(err),
);

export default api;
/* --- END: Edited by Copilot Space --- */